/**
 * useLegalDocumentsItems
 *
 * Returns the static list of seven legal-document rows shown on
 * `LegalDocumentsPage`. Mirrors Flutter's `LegalDocumentsScreenState.initState`
 * (lib/presentation/screens/legal/legal_documents_screen.dart:22-59).
 *
 * Navigation is intentionally not part of the entity — the page owns the
 * type→route switch, mirroring Flutter's `_onItemTap`.
 */

import { useMemo } from 'react';
import { LegalDocumentItemType } from '@/domain/enums/legalDocumentItemType';
import type { LegalDocumentItemEntity } from '@/domain/entities/legal/legalDocumentItemEntity';
import { useLocale } from '@/presentation/contexts/LocaleContext';

export const useLegalDocumentsItems = (): LegalDocumentItemEntity[] => {
    const { l10n } = useLocale();
    const legalLabels = l10n.legal;

    return useMemo(() => {
        return [
            {
                type: LegalDocumentItemType.terms,
                title: legalLabels.termsOfUse,
                description: legalLabels.termsOfUseDescription,
                iconPath: '/assets/images/bio.png',
            },
            {
                type: LegalDocumentItemType.coinsPolicy,
                title: legalLabels.coinsPolicy,
                description: legalLabels.coinsPolicyDescription,
                iconPath: '/assets/images/coins.png',
            },
            {
                type: LegalDocumentItemType.rewardsPolicy,
                title: legalLabels.rewardsPolicy,
                description: legalLabels.rewardsPolicyDescription,
                iconPath: '/assets/images/diamond.png',
            },
            {
                type: LegalDocumentItemType.exclusiveSubscriptionsPolicy,
                title: legalLabels.exclusiveSubscriptionsPolicy,
                description: legalLabels.exclusiveSubscriptionsPolicyDescription,
                iconPath: '/assets/images/subscribers.png',
            },
            {
                type: LegalDocumentItemType.premiumSubscriptionsPolicy,
                title: legalLabels.premiumSubscriptionsPolicy,
                description: legalLabels.premiumSubscriptionsPolicyDescription,
                iconPath: '/assets/images/premium.png',
            },
            {
                type: LegalDocumentItemType.privacyPolicy,
                title: legalLabels.privacyPolicy,
                description: legalLabels.privacyPolicyDescription,
                iconPath: '/assets/images/locked.png',
            },
            {
                type: LegalDocumentItemType.communityGuidelines,
                title: legalLabels.communityGuidelines,
                description: legalLabels.communityGuidelinesDescription,
                iconPath: '/assets/images/roadmap.png',
            },
        ];
    }, [legalLabels]);
};
